import { render, staticRenderFns } from "./select-people.vue?vue&type=template&id=1eb23292&scoped=true&"
import script from "./select-people.vue?vue&type=script&lang=js&"
export * from "./select-people.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb23292",
  null
  
)

export default component.exports